import { createCrudSagas } from "./CrudSagas";
import { StateDefinitionsActions } from "../reducers/StateDefinitionsRedux";

const crudSagas = createCrudSagas("stateDefinitions", StateDefinitionsActions);

export const findStateDefinitions = crudSagas.findStateDefinitions;
export const getStateDefinition = crudSagas.getStateDefinition;
export const createStateDefinition = crudSagas.createStateDefinition;
export const updateStateDefinition = crudSagas.updateStateDefinition;
